<template>
  <div class="watchlist">
    <div class="watchlist-m">
      <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="设备编号">
          <el-input v-model.trim="formInline.inputdeviceno" placeholder="请输入设备编号" clearable
            @keyup.enter.native.prevent="enterSearchMember"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="warning" plain class="el-icon-plus" @click="dialogFormVisible = true">新增</el-button>

        </el-form-item> -->
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="list" style="width: 100%" :row-style="tableRowStyle"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="tableHeaderColor">
          <el-table-column label="设备编号" style="width: 20%" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
                label="设备类型"
                 style="width: 20%"
                 align="center"
                  :show-overflow-tooltip="true"
                >
                <template slot-scope="scope">
                    <span style="margin-left: 10px" v-if="scope.row.deviceType===1">孝心手环</span>
                </template>
          </el-table-column>-->
          <el-table-column label="设备名称" style="width: 20%" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备描述" style="width: 20%" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="老人姓名" align="center" style="width: 20%" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px; color: orange" v-if="scope.row.oldmanName == null">暂未绑定</span>
              <span style="margin-left: 10px" v-else>{{
                scope.row.oldmanName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" :width="480" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" plain @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              <el-button type="success" size="mini" v-if="scope.row.status" plain
                @click="handleBangdi(scope.$index, scope.row)">绑定</el-button>
              <el-button type="primary" size="mini" v-if="!scope.row.status" plain
                @click="handleJiebang(scope.$index, scope.row)">解绑</el-button>

                
              <el-button type="info" size="mini" plain @click="handleWatchDetail(scope.$index, scope.row)">详情</el-button>
              <el-button type="success" size="mini" plain @click="handleSetarea(scope.$index, scope.row)">设置</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize"
          align="center" class="fenye"></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog title="新增设备信息" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" class="watchxz" @close="closexz">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="xzdate">
            <el-input v-model.trim="form.xzdate" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="xzname">
            <el-input v-model.trim="form.xzname" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="xzsec">
            <el-input v-model.trim="form.xzsec" type="textarea" :rows="3" placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出修改-->
      <el-dialog title="修改设备信息" :visible.sync="dialogFormEdit" :close-on-click-modal="false"
        :close-on-press-escape="false" class="watchedit">
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="editdate">
            <el-input disabled v-model.trim="formedit.editdate" auto-complete="off" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="editname">
            <el-input v-model.trim="formedit.editname" auto-complete="off" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="editsec">
            <el-input v-model.trim="formedit.editsec" auto-complete="off" type="textarea" :rows="3"
              placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button type="primary" @click="submitFormEdit('formedit')" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出填写老人姓名-->
      <el-dialog title="绑定孝心手环" :visible.sync="dialogFormBangdi" :close-on-click-modal="false"
        :close-on-press-escape="false" class="bangdilocation" @close="closeBangdi">
        <el-form ref="formBangdi" :model="formBangdi" :rules="rules">
          <el-form-item label="设备编号 :" :label-width="formLabelWidth">
            <span>{{ formBangdi.bindDeviceNo }}</span>
          </el-form-item>
          <el-form-item label="老人姓名" :label-width="formLabelWidth" prop="oldmanName">
            <el-select v-model="formBangdi.oldmanName" placeholder="请选择老人" filterable @change="currentSel">
              <el-option v-for="(item, index) in oldmanNameIdList" :key="index" :label="item.oldName"
                :value="item.oldName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="老人身份证 :" :label-width="formLabelWidth">
            <span v-if="formBangdi.oldIdCard">{{ formBangdi.oldIdCard }}</span>
            <span v-else>暂无数据</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelBangdi">取 消</el-button>
          <el-button type="primary" @click="submitFormBangdi('formBangdi')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      addLoading: false,
      editLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      allList: [], //返回所有的门禁卡结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      oldmanNameIdList: [], //老人姓名和Id和身份证（用于下拉菜单展示老人以及绑定的时候 删除老人操作）
      oldmanIdNameUnshift: [], //用于解绑时 添加老人操作
      oldIdCard: [], //老人身份证
      oldmanList: [], //老人所有信息列表
      formInline: {
        inputdeviceno: "",
      },

      //绑定老人
      dialogFormBangdi: false,
      formBangdi: {
        oldmanName: "", //老人姓名
        oldmanId: "", //老人id
        deviceId: "", //设备id
        oldIdCard: "", //老人身份证编号
        bindDeviceNo: "", //绑定模态框弹出的设备编号
      },

      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: "",
        // xzaddress:'',
      },
      formLabelWidth: "120px",

      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: "",
        // editaddress:'',
      },

      rules: {
        // 新增正则验证匹配规则
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          //{min: 15, max:20, message: '长度在 15到 20 位的数字'},
          //{ pattern: /^[0-9]+$/, message: '请输入由数字组成的字符' }
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          // { pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_])[a-z0-9_]+$/gi, message: '请输入由数字,大小写字母和_组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
        ],
        xzsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 50, message: "长度在 1到 50 个字符" },
        ],
        xzname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 20, message: "长度在 1到 20 个字符" },
        ],

        // 修改正则验证匹配规则
        editdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          //{min: 15, max:20, message: '长度在 15到 20 位的数字'},
          //{ pattern: /^[0-9]+$/, message: '请输入由数字组成的字符' },
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_])[a-z0-9_]+$/gi, message: '请输入由数字,大小写字母和_组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
        ],
        editsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 50, message: "长度在 1到 50 个字符" },
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 20, message: "长度在 1到 20 个字符" },
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        oldmanName: [
          {
            required: true, //是否必填
            message: "请选择老人姓名", //规则
            trigger: "change", //何事件触发
          },
        ],
        oldmanId: [],
      },
      fileFlag: false,
    };
  },
  methods: {
    //选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },

    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
      }
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

    //弹出框下拉菜单change事件
    currentSel(selVal) {
      this.formBangdi.oldmanName = selVal;
      this.oldmanNameIdList.forEach((item, index) => {
        if (this.formBangdi.oldmanName == item.oldName) {
          this.formBangdi.oldIdCard = item.oldIdCard;
        }
        console.log(item.oldName);
        console.log(item.oldIdCard);
      });
    },

    //关闭绑定dialog的回调
    closeBangdi() {
      this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
    },

    //绑定 取消的dialog
    cancelBangdi() {
      this.dialogFormBangdi = false;
      this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
    },

    //绑定,弹出模态框填写老人信息
    handleBangdi(index, row) {
      console.log(index, row);
      this.dialogFormBangdi = true;
      this.formBangdi = Object.assign({}, row); //深拷贝数据
      console.log(this.formBangdi.id);
      this.formBangdi.deviceId = this.formBangdi.id;
      this.formBangdi.bindDeviceNo = this.formBangdi.deviceNo;
      //点击绑定时弹出dialog,然后循环判断select菜单已经绑定的老人，如果已经绑定就将其移除
      this.allList.forEach((item, index) => {
        console.log(item, index);
        this.oldmanNameIdList.forEach((item2, index2) => {
          // console.log(item2,index2);
          //通过老人的oldmanId和已经绑定的状态 bind  true为绑定  fasle为解绑   来进行判断
          if (item2.oldmanId == item.oldmanId && item.bind == true) {
            this.oldmanNameIdList.splice(index2, 1); //删除数组中对应的值
          }
        });
      });
      console.log(this.oldmanNameIdList);
    },

    //绑定孝心手环提交数据
    submitFormBangdi(datainfo) {
      //循环判断 取出对应的oldmanId和oldmanName
      this.oldmanNameIdList.forEach((item, index) => {
        if (this.formBangdi.oldmanName == item.oldName) {
          this.formBangdi.oldmanId = item.oldmanId;
        }
        console.log(item.oldName);
        console.log(item.oldmanId);
      });
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          let param = {
            deviceId: this.formBangdi.deviceId,
            oldmanId: this.formBangdi.oldmanId,
            oldmanName: this.formBangdi.oldmanName,
          };
          console.log(param);
          this.$postJson("dmc/watch/bindDmcWatchOldman", param).then((res) => {
            console.log(res);
            this.dialogFormBangdi = false;
            if (res.code == "10061012") {
              setTimeout(() => {
                this.$message({
                  message: "孝心手环已经绑定过",
                  type: "error",
                });
              }, 300);
            } else {
              //绑定成功后 循环判断 将对应的老人从数组中删除  老人姓名从select菜单中删除
              this.oldmanNameIdList.forEach((item, index) => {
                console.log(item, index);
                if (this.formBangdi.oldmanName == item.oldName) {
                  this.oldmanNameIdList.splice(index, 1);
                }
              });
              console.log(this.formBangdi.oldmanName);
              this.$set(this.formedit, "status", false);
              this.getTableData();
              this.getALLDate();
              console.log(this.formedit.status);
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              }, 300);
            }
          });
        }
      });
    },

    //解绑
    handleJiebang($index, row) {
      console.log($index, row);
      var list = []; //声明一个空数组，用于存储解绑的老人信息
      //循环另一个集合  判断取到对应的老人信息
      this.oldmanIdNameUnshift.forEach((item, index) => {
        console.log(item, index);
        console.log(row.oldmanId);
        if (row.oldmanId == item.oldmanId) {
          var obj = {};
          obj.oldName = item.oldName;
          obj.oldmanId = item.oldmanId;
          obj.oldIdCard = item.oldIdCard;
          list.push(obj);
        }
      });
      console.log(list);
      console.log(row);
      this.$confirm("此操作将解除绑定, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          this.formBangdi = Object.assign({}, row); //深拷贝数据
          let deviceId = this.formBangdi.id;
          this.$postJson(
            "dmc/watch/breakDmcWatchOldmanByDeviceId/" + deviceId
          ).then((res) => {
            //通过循环判断解绑的老人oldmanId ,将解绑的老人信息 再重新添加进oldmanNameIdList的集合中  使其在select下拉菜单老人列表中显示出来
            this.allList.forEach((item, index) => {
              //console.log(item,index);
              console.log(item.oldmanId == row.oldmanId);
              if (item.oldmanId == row.oldmanId) {
                this.oldmanNameIdList.unshift(list[0]);
              }
            });
            //数组中的对象去重，因为在老人列表修改会导致数组有重复项
            // let obj={};
            //
            // // this.oldmanNameIdList = this.oldmanNameIdList.reduce((cur,next) => {
            // //     obj[next.oldName] ? "" : obj[next.oldName] = true && cur.push(next);
            // //     return cur;
            // // },[]) //设置cur默认类型为数组，并且初始值为空的数组

            console.log(this.oldmanNameIdList);
            console.log(res);
            localStorage.removeItem("volume" + deviceId); //解除孝心手环绑定清除存储的记录
            localStorage.removeItem("switchGps" + deviceId); //解除孝心手环绑定清除存储的记录
            localStorage.removeItem("switchWhite" + deviceId); //解除孝心手环绑定清除存储的记录
            localStorage.removeItem("switchYellowKeySms" + deviceId); //解除孝心手环绑定清除存储的记录
            localStorage.removeItem("switchRedKeySms" + deviceId); //解除孝心手环绑定清除存储的记录
            this.$set(this.formedit, "status", true);
            this.getTableData();
            this.getALLDate();
            this.getOldmanList();
            if (res.code == "500") {
              this.$message({
                message: "孝心手环尚未绑定",
                type: "error",
              });
            } else {
              this.$message({
                message: res.message,
                type: "success",
              });
            }
            this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消绑定",
          });
        });
    },

    //详情
    handleWatchDetail(index, row) {
      console.log(row);
      if (row.bind == false) {
        this.$message({
          type: "error",
          message: "该设备还未绑定,请先绑定后再进行操作!",
        });
      } else {
        this.formBangdi = Object.assign({}, row); //深拷贝数据
        var id = this.formBangdi.id;
        var oldName = this.formBangdi.oldmanName;
        var oldmanId = this.formBangdi.oldmanId;
        bus.$emit("homePage", {
          type: "jump",
          path: "/watchdetail",
          title: '手表详情',
          params: {
            id: id,
            oldName: oldName,
            oldmanId: oldmanId
          }
        });

      }
    },
    //手环设置
    handleSetarea(index, row) {
      if (row.bind == false) {
        this.$message({
          type: "error",
          message: "该设备还未绑定,请先绑定后再进行操作!",
        });
      } else {
        this.formedit = Object.assign({}, row); //深拷贝数据
        let id = this.formedit.id;
        let deviceNo = this.formedit.deviceNo;
        bus.$emit("homePage", {
          type: "jump",
          path: "/setarea",
          title: '手表设置',
          params: {
            id: id,
            deviceNo: deviceNo
          }
        });
      }
    },

    //点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      console.log(this.listIndex);
      // this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      console.log(this.formedit.id);
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
      console.log(this.formedit.editdate);
    },

    // 点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate((valid) => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate,
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/watch/edit", param)
            .then((res) => {
              console.log(res);
              this.editLoading = false;
              this.dialogFormEdit = false; //关闭修改弹窗
              this.$bus.$emit("submitFormEditchange_watchlist"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success",
                  });
                }, 300);
                console.log("修改成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
            })
            .catch((res) => {
              this.$message({
                type: "error",
                message: res.message,
              });
            });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },

    //删除
    handleDelete(index, row) {
      if (row.bind == false) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        })
          .then(() => {
            console.log(index, row);
            let id = row.id;
            console.log(id);
            this.$postJson(`dmc/propertyManagement/untie`, {
              deviceIds: [id],
            }).then((res) => {
              //旧 dmc/watch/deleteById/
              if (res.code == 200) {
                this.$bus.$emit("handleDeletechange_watchlist"); //发送一个change事件
                console.log(res);
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!",
        });
      }
    },

    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    //新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate,
          };
          console.log(param);
          //this.loading = true
          this.addLoading = true;
          this.$postJson(
            "dmc/propertyManagement/bindDeviceMerchant",
            param
          ).then((res) => {
            //旧： dmc/watch/add
            console.log(res);
            this.addLoading = false;
            this.dialogFormVisible = false;
            this.$refs.form.resetFields(); //移除校验结果并重置字段值
            this.$bus.$emit("submitFormchange_watchlist"); //发送一个change事件
            if (res.code == "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              }, 300);
              console.log("提交成功!");
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }, 300);
            }
            //console.log(this.$store.state.count)
            //this.loading = false
          });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },

    //获取分页的孝心手环数据   只获取pageSize条数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno,
        oldmanId: this.oldmanId,
        oldmanName: this.oldmanName,
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/watch/queryGroupWatchListWithPage", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            //console.log(this.list)
            setTimeout(() => {
              this.loading = false;
            }, 500);
            var num = 0;
            var num2 = 0;
            res.result.list.forEach((item, index) => {
              //console.log(item.bind)
              var bind = item.bind;
              res.result.list.forEach((item, index) => {
                //console.log(item)
                if (item.bind == true) {
                  this.$set(item, "status", false);
                } else if (item.bind == false) {
                  this.$set(item, "status", true);
                }
              });
            });
          } else {
            this.list = [];
            this.tableData = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          }
        }
      );
    },

    //获取所有的孝心手环列表数据  ，获取了全部数据
    getALLDate() {
      let param = {
        pageNum: 0,
        pageSize: 0,
      };
      this.$postJson("dmc/watch/queryGroupWatchListWithPage", param).then(
        (res) => {
          console.log(res);
          this.allList = res.result.list;
          console.log(this.allList);
        }
      );
    },

    //获取所有老人信息
    getOldmanList() {
      let param = {
        pageNum: 1,
        pageSize: 10000,
      };
      this.$postJson("omc/Oldman/queryOldmanNotBindWatchList", param).then(
        (res) => {
          this.oldmanList = res.result.list;
          var arroldNameId = [];
          var objoldNameId = {};
          res.result.list.forEach((item, index) => {
            objoldNameId = {
              oldName: item.oldName,
              oldmanId: item.oldmanId,
              oldIdCard: item.oldIdCard,
            };
            arroldNameId.push(objoldNameId);
          });
          //深拷贝两个数组去操作select菜单 老人的绑定时 ，将老人删除  解除绑定时，将老人重新添加进老人select菜单中
          this.oldmanNameIdList = Object.assign([], arroldNameId); //深拷贝记录
          this.oldmanIdNameUnshift = Object.assign([], arroldNameId); //深拷贝记录
        }
      );
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },
  },
  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.getTableData();
    this.getOldmanList();
    this.getALLDate();
  },

  mounted() {
    //监听submitFormchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormchange_watchlist", () => {
      this.getTableData();
    });
    //监听handleDeletechange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("handleDeletechange_watchlist", () => {
      this.getTableData();
    });
    //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormEditchange_watchlist", () => {
      this.getTableData();
    });
  },
};
</script>
<style lang="scss" scoped>
.watchlist {
  .watchlist-m {
    padding: 10px 0 0 5px;
  }
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}

.xq {
  color: green !important;
  margin-right: 15px;
}

.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .watchxz .el-dialog {
    width: 30% !important;
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .watchedit .el-dialog {
    width: 30% !important;
  }
}

//绑定智能电话机位置和房间的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .bangdilocation .el-dialog {
    width: 30% !important;
  }
}
</style>